<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('users') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="toolbar">
			<button id="persons_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="persons_table_toolbar_remove" :title="$t('delete')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('delete') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.user') }}</a></li>
				<li><a tabindex="-1">{{ $t('browse.related.users') }}</a></li>
				<li><a tabindex="-1">{{ $t('remove.user') }}</a></li>
			</ul>
		</div>

		<div id="person-users-table-window" class="modal fade modal-window control-container related-user-modal"
			 tabindex="-1" role="dialog" aria-labelledby="person-users-manager" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">

					<div id="person-user_toolbar"></div>

					<div class="row table-area-row">
						<div class="col-sm-12 table-area-col">
							<table id="person-users_table" class="table"></table>
						</div>
					</div>

					<div class="row">
						<div class="col-sm-12">
							<div class="table-footer">
								<div class="row">
									<div class="col-sm-10 col-xs-8">
										<div id="person-users_status-bar" class="status-bar status-bar_center"></div>
									</div>
									<div class="col-sm-2 col-xs-4">
										<div class="page-sizer-container"></div>
									</div>
									<div class="col-sm-12 col-xs-12">
										<div id="person-users_pager" class="pager"></div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div id="person-users_context-menu" class="context-menu">
						<ul class="dropdown-menu" role="menu">
							<li><a tabindex="-1">{{ $t('go.to.company.profile') }}</a></li>
						</ul>
					</div>

				</div>
			</div>
		</div>

		<users-modal v-if="isVisibleModal" :id="id" :action="action" :active-attribute="activeAttribute" :person="person" @close-modal="isVisibleModal = false"/>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { IndividualPersonManager } from '@/core/administration/IndividualPersonManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'
import Users from 'components/modal/Users'

export default {
	name: 'Users',
	components: {
		'users-modal': Users
	},
	data () {
		return {
			id: null,
			action: null,
			activeAttribute: null,
			person: {},
			isVisibleModal: false
		}
	},
	metaInfo () {
		return {
			title: this.$t('users')
		}
	},
	methods: {
		initIndividualPersonManager: function (action, id, activeAttribute, person) {
			this.id = id
			this.action = action
			this.activeAttribute = activeAttribute
			this.person = person
			this.isVisibleModal = true
		}
	},
	mounted () {
		let vm = this
		window.manager = new IndividualPersonManager(this)

		let personUsersColumns = [
			{

				'title': 'company',
				'columnName': 'company'
			},
			{
				'title': 'group',
				'columnName': 'group'
			}
		]

		window.personUsersTable = new Table('personUsersTable', {
				selector: '#person-users_table',
				columns: personUsersColumns,
				dynamicLoading: false,
				pageSizer: '#person-users_table_toolbar_page-size',
				pager: '#person-users_pager',
				contextMenu: '#person-users_context-menu',
				toolbar: '#person-user_toolbar',
				statusBar: '#person-users_status-bar',
				doubleClickMode: 'edit',
				frozen: 'none'
			},
			{
				contextMenu: {
					1: function (item) {
						location.href = '/company/' + item.companyId
					}
				},
				doubleClick: {
					'edit': function (item, table) {
						table.callbacks.contextMenu['1'](item)
					}
				}
			})

		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'first.name',
				'columnName': 'firstName',
				'attribute': 'person_firstName'
			},
			{
				'title': 'last.name',
				'columnName': 'lastName',
				'attribute': 'person_lastName'
			},
			{
				'title': 'user.login',
				'columnName': 'login',
				'attribute': 'person_login'
			},
			{
				'title': 'description',
				'columnName': 'description',
				'attribute': 'person_description'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		this.$store.dispatch(USER_CONFIG, 'individualPersonsTable.tableState')
			.then((config) => {
				window.table = new Table('individualPersonsTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						frozenFirstColumn: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								vm.initIndividualPersonManager('edit', item.id, attribute, item)
							},
							2: function (item) {
								$('#person-users-table-window').modal()

								$.ajax({
									type: 'POST',
									url: window.urlContext + 'users',
									data: { personId: item.id },

									success: function (data) {
										personUsersTable.table.bootstrapTable('load', [])
										personUsersTable.updateData(data)
									}
								})
							},
							3: function (item) {
								manager.initRemoveIndividualPerson(item.id)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {

					})
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'individual-persons/load')
				table.setDataIDsUrl(window.urlContext + 'individual-persons/ids')
				table.setDataSortUrl(window.urlContext + 'individual-persons/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG individualPersonsTable', error)
			})

		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#persons_table_toolbar_add').click(function () {
			vm.initIndividualPersonManager('create', undefined, undefined, undefined)
		})

		$('#persons_table_toolbar_remove').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert(vm.$t('no.selected.individual.persons'), 'warning')
			} else {
				manager.initRemoveIndividualPersons(ids)
			}
		})

		$('#person-users-table-window').on('hide.bs.modal', function () {
			table.initTable()
		})

		$(window).resize(function () {
			resizeTableHeight()
			table.frozenTableElements.setFrozenHeaderCellsWidth()
		})
	}
}
</script>

<style scoped>

</style>
